import { Component, Input } from '@angular/core';
import { NgCircleProgressModule } from 'ng-circle-progress';

@Component({
  selector: 'app-circle-graph',
  imports: [NgCircleProgressModule],
  providers: [
    NgCircleProgressModule.forRoot({
      radius: 100,
      outerStrokeWidth: 16,
      outerStrokeColor: '#78C000',
      animationDuration: 300,
    }).providers!,
  ],
  templateUrl: './circle-graph.component.html',
})
export class CircleGraphComponent {
  @Input({ required: true }) data!: number;
  @Input() baseColour: string = '#ADDDF7';
  @Input() dataColour: string = '#6C7593';
  @Input() strokeWidth: number = 20;
  @Input() title: string = '';
  @Input() subTitle: string = '';
  @Input() radius: number = 64;
}
